import { render, staticRenderFns } from "./UpdateAssetLimit.vue?vue&type=template&id=c89d5f4e"
import script from "./UpdateAssetLimit.vue?vue&type=script&lang=js"
export * from "./UpdateAssetLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports